
export const appleRedirectURL = process.env.NEXT_PUBLIC_APPLE_REDIRECT_URL || "https://home-l.s.id/auth/login/apple"

export const appleAppId = process.env.NEXT_PUBLIC_APPLE_APPID || "id.sdot.home"

export const appleIdScript = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js"
